import axios from 'axios'
import { handleResponse, handleError } from '../helpers/api'
import store from '../store'

const apiRulesClient = axios.create({
  baseURL: `${window.config.VUE_APP_API_BASE_URL}/Report`,
  withCredentials: true,
  timeout: 6000000
})

export const ReportsService = {
  accumulatedInvoiceCustomer,
  invoiceCustomer,
  accumulatedDeposits,
  deposits,
  aplreport
}

function accumulatedInvoiceCustomer(payload) {
  return this.invoiceCustomer(payload)
}

async function invoiceCustomer(payload) {
  let { startDate, endDate, SqlReportType, isXml, OutputType } = payload
  OutputType = isXml ? 2 : 1
  startDate += ' 00:00:00'
  endDate += ' 23:59:59'
  return await apiRulesClient
    .get(
      `/invoiceCustomer?startDate=${startDate}&endDate=${endDate}&SqlReportType=${SqlReportType}${OutputType ? '&OutputType='+OutputType : ''}`,
      getHeader()
    )
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

function accumulatedDeposits(payload) {
  return this.deposits(payload)
}

async function deposits(payload) {
  let { startDate, endDate, SqlReportType } = payload
  startDate += ' 00:00:00'
  endDate += ' 23:59:59'
  return await apiRulesClient
    .get(
      `/po_report?startDate=${startDate}&endDate=${endDate}&SqlReportType=${SqlReportType}`,
      getHeader()
    )
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

function getHeader() {
  return {
    headers: { Authorization: 'bearer ' + store.getters.jwtToken }
  }
}

async function aplreport(payload) {
  return await apiRulesClient
    .post(`/apl-report`, payload, getHeader())
    //.then(handleResponse)
    .then(response => {
      console.log(response)
      return response // Return the response directly
      // Handle successful response
    })
    .catch(e => {
      return handleError(e)
    })
}
